const Contact = () => {
    return (
        <div className="contact">
            <h2>Contact Information</h2>
            <p>For any questions, concerns, or feedback, please contact [that nerd who does the computer stuff] on Slack or email!</p>
        </div>
    );
}
 
export default Contact;